import { Component, Vue, Prop } from "vue-property-decorator";
@Component({
})
export default class TimeAnalysisBarChart extends Vue {
  @Prop({ default: () => ([]) }) readonly columns: Array<any>;
  @Prop({ default: () => ([]) }) readonly dataValue: any;
  @Prop({ default: null }) index: number

  mounted() {
    this.init()
  }

  seriesDataItem(obj, color){
    const data = []
    Object.keys(obj).forEach(function(key){
      if (key !== 'title') {
        data.push({name: key, value: obj[key], itemStyle: {color: color[key]}})
      }
    })
    return data
  }

  init() {
    const color = {}
    this.columns.map(column =>{
      color[column.wcsName] = column.color
    })
    const seriesData = this.seriesDataItem(this.dataValue, color)
    // 基于准备好的dom，初始化echarts实例
    var myChart = (this as any).$echarts.init(
      this.$refs.myChart as any
    );
    // 指定图表的配置项和数据
    var option = {
      title:{
        text: this.dataValue.title
      },
      tooltip: {
        show: true,
        trigger: "item",
        formatter: "{b}: {c}h ({d}%)"
      },
      legend: {
        show: false
      },
      series: [
        {
          type: "pie",
          radius: '55%',
          center: ['40%', '50%'],
          label: {
            formatter: '{d}%'
          },
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)',
            }
          },
          data: seriesData
        }
      ]
    };
    // 使用刚指定的配置项和数据显示图表。
    myChart.setOption(option);
  }

  render() {
    return (
      <div ref="myChart" style={{width: (65 * this.columns.length * this.dataValue.length) + 'px', height: '300px'}}></div>
    )
  }
}